import client from "@irati/utils/services/apollo"
import {
  PlatformMetrics,
  PerksMetrics,
  TeamPerksMetrics
} from "@irati/types"

import teamPerksMetricsQuery from "./apollo/query/TeamPerksMetrics"
import perksMetricsQuery from "./apollo/query/PerksMetrics"
import platformMetricsQuery from "./apollo/query/PlatformMetrics"

class AdminService {
  getTeamPerksMetrics = (tenantId: string): Promise<TeamPerksMetrics> => {
    return client
      .query({query: teamPerksMetricsQuery, variables: {tenantId}, fetchPolicy: "network-only"})
      .then(({data}) => data.teamPerksMetrics)
  }

  getPerksMetrics = (tenantId: string): Promise<PerksMetrics> => {
    return client
      .query({query: perksMetricsQuery, variables: {tenantId}, fetchPolicy: "network-only"})
      .then(({data}) => data.perksMetrics)
  }


  getPlatformMetrics = (tenantId: string): Promise<PlatformMetrics> => {
    return client
      .query({query: platformMetricsQuery , variables: {tenantId}, fetchPolicy: "network-only"})
      .then(({data}) => data.platformMetrics)
  }
}

export default new AdminService()
